/* import __COLOCATED_TEMPLATE__ from './reviewable-field-textarea.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./reviewable-field-textarea.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));